import fetch from './api'
// 获取用户登录信息
export const getUserInfo = params => {
  return fetch({
      url: '/api/userinfo',
      method: 'get',
      params: params
  })
}

// 用户退出
export const signOut = params => {
    return fetch({
        url: '/passport/logout',
        method: 'get',
        params: params
    })
}



// WEBPACK FOOTER //
// ./src/api/interface-user.js